define.alias("checkout/components/seamless-checkout/checkout-modal", "settings/components/seamless-checkout/checkout-modal");